// extracted by mini-css-extract-plugin
module.exports = {"mailInnerContent":"mailInnerContent_mailInnerContent__3-ZQP"};